// baseLaunchers.js

import { ADD_MODAL_SPECIAL_KEYS } from 'node/tabs/unifiedNodeTabKeys';

/**
 * Base-scoped create actions shown in top-level AddModal (sidebar / mobile New).
 * Mixed alphabetically with node types in the picker.
 * Sidebar bucket order is preserved here only as a documentation convenience.
 */
export const BASE_LAUNCHER_DEFS = Object.freeze([
  {
    key: ADD_MODAL_SPECIAL_KEYS.DATABASE,
    label: 'Collection',
    iconKey: 'database',
    description: 'Create a new collection for this base.',
  },
  {
    key: ADD_MODAL_SPECIAL_KEYS.MESSAGE,
    label: 'Message',
    iconKey: 'chat',
    description: 'Start or open a direct message.',
  },
  {
    key: ADD_MODAL_SPECIAL_KEYS.CHANNEL,
    label: 'Channel',
    iconKey: 'tag',
    description: 'Create a new channel.',
  },
  {
    key: ADD_MODAL_SPECIAL_KEYS.DASHBOARD,
    label: 'Dashboard',
    iconKey: 'dashboard',
    description: 'Create a new dashboard.',
  },
]);

const BASE_LAUNCHER_KEY_SET = new Set(
  BASE_LAUNCHER_DEFS.map((def) => def.key),
);

/**
 * Returns true when the key is a base create launcher (not a node type).
 *
 * @param {string|null|undefined} typeKey
 * @returns {boolean}
 */
export function isBaseLauncherKey(typeKey) {
  const normalized = typeof typeKey === 'string' ? typeKey.trim() : '';
  if (!normalized) return false;
  return BASE_LAUNCHER_KEY_SET.has(normalized);
}

/**
 * Opens the matching base create modal for a launcher key.
 *
 * @param {string|null|undefined} typeKey
 * @param {object} openers - Open handlers from useBaseCreateModals.
 * @returns {boolean} True when the key was handled as a launcher.
 */
export function openBaseLauncher(typeKey, openers = {}) {
  switch (typeKey) {
    case ADD_MODAL_SPECIAL_KEYS.DATABASE:
      openers.openDatabase?.();
      return true;
    case ADD_MODAL_SPECIAL_KEYS.MESSAGE:
      openers.openMessage?.();
      return true;
    case ADD_MODAL_SPECIAL_KEYS.CHANNEL:
      openers.openChannel?.();
      return true;
    case ADD_MODAL_SPECIAL_KEYS.DASHBOARD:
      openers.openDashboard?.();
      return true;
    default:
      return false;
  }
}
